// PropertyCardSettingsModal — feature-local per-card action-list modal.
//
// Renders the canonical .project-modal envelope with .modal-body
// stacked .modal-btn-action rows (per design-map.md A.9 "action-list
// modal"). One modal instance per card; the id prop is constructed
// from property.id by the parent, guaranteeing runtime uniqueness
// (per R2 STEP R2.9: no global modal manager, no centralized
// registry).
//
// Bootstrap modal coupling (data-bs-toggle / data-bs-target) is
// preserved verbatim from design/index.html so existing Bootstrap JS
// in the app shell continues to manage open/close — same convention
// as the existing components/profile/* modals. No portal, no escape
// listener, no body-scroll lock here.
//
// Item shape:
//   { id, label, icon?, kind?: 'link'|'button', href?, onClick?,
//     danger?, target?, dismiss?: boolean, disabled?: boolean }
// Items are passed by the consuming screen — the modal does NOT
// derive item lists from any ownership semantic. Per CLAUDE.md
// "Semantic Rendering Doctrine": shared renderers ACCEPT semantic
// data, must not DERIVE it.
//
// R5.2 — `disabled: true` on a button item renders the affordance
// inert (native `disabled` + `aria-disabled`). Click never fires;
// Bootstrap dismiss does not run. Topology + .modal-btn-action class
// preserved verbatim so spacing/hierarchy remain canonical.

function PropertyCardSettingsModal({ id, items = [] }) {
  if (!id || items.length === 0) return null;

  return (
    <div className="modals">
      <div
        className="modal fade project-modal property-card-settings-modal"
        id={id}
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              {items.map((item) => {
                const itemClass = item.danger
                  ? "modal-btn-action text-danger"
                  : "modal-btn-action";

                if (item.kind === "link" && item.href) {
                  return (
                    <a
                      key={item.id}
                      href={item.href}
                      target={item.target || undefined}
                      rel={item.target ? "noopener noreferrer" : undefined}
                      className={itemClass}
                      data-bs-dismiss={item.dismiss ? "modal" : undefined}
                    >
                      {item.icon ? (
                        <i
                          className={`${item.icon} modal-btn-action__icon`}
                          aria-hidden="true"
                        />
                      ) : null}
                      <span className="modal-btn-action__label">{item.label}</span>
                    </a>
                  );
                }

                const isDisabled = Boolean(item.disabled);
                return (
                  <button
                    key={item.id}
                    type="button"
                    className={itemClass}
                    onClick={isDisabled ? undefined : item.onClick}
                    disabled={isDisabled}
                    aria-disabled={isDisabled || undefined}
                    data-bs-dismiss={
                      isDisabled
                        ? undefined
                        : item.dismiss === false
                        ? undefined
                        : "modal"
                    }
                  >
                    {item.icon ? (
                      <i
                        className={`${item.icon} modal-btn-action__icon`}
                        aria-hidden="true"
                      />
                    ) : null}
                    <span className="modal-btn-action__label">{item.label}</span>
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PropertyCardSettingsModal;
